// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FoWQ","left":"styles_left__1kvK7","desktopActions":"styles_desktopActions__2I_81","title":"styles_title__1SJYN"};